import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import JobFullDetailsMainDetailsDriverBlock
  from './main-details/job-full-details-main-details-driver-block.jsx';
import moment from 'moment';
export default class JobFullDetailsMainDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null
    }
    this.handleThreeWordsUpdate = this.handleThreeWordsUpdate.bind(this);
    this.invoiceNotesRef = React.createRef();
    this.handleSaveInvoiceNotes = this.handleSaveInvoiceNotes.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  handleThreeWordsUpdate(e){
    let url = "/api/v1/portal/jobs/update-three-words/"+this.state.data.id;
    let that = this;
    $.ajax({
      url: url,
      data: {
        api_token: window.api_token,
        three_words_of_dropoff_address: $('#three_words_of_dropoff_address').val(),
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
    //  alert('cancelled');
      that.state.data.three_words_of_dropoff_address = $('#three_words_of_dropoff_address').val()
      that.setState({data:that.state.data});
    });
  }
  handleJobTypeOption(e){
    this.setState({jobTypeOption:e.currentTarget.value});
  }
  handleJobTypeOptionSave(){
    let url = "/api/v1/portal/jobs/set-job-type-option/"+this.state.data.id;
    let job_type = this.state.jobTypeOption;
    let that = this;
    $.ajax({
      url: url,
      data: {
        api_token: window.api_token,
        job_type: job_type,
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
      $('#infomodallabel').html('Success');
      $('#infomodal .modal-body').html(data);
      $('#infomodal').modal();
    }).catch(function(err) { 
      let errors = err.responseText; 
        errors = JSON.parse(errors);
      $('#infomodallabel').html('Error');
      $('#infomodal .modal-body').html('Sorry, '+errors);
      $('#infomodal').modal();
      
    });
  }
  handleSaveInvoiceNotes() {
    try {
      let oldInvoiceNote = this.state.data.invoice_notes;
  
      if (!this.invoiceNotesRef || !this.invoiceNotesRef.current) {
        console.error('Textarea ref not set');
        return;
      }
      if (!this.state || !this.state.data || !this.state.data.id) {
        console.error('Job ID not available in state');
        return;
      }
  
      const invoice_notes = this.invoiceNotesRef.current.value;
  
      if (invoice_notes === oldInvoiceNote) {
        $('#infomodallabel').html('No Changes');
        $('#infomodal .modal-body').html('Invoice notes are unchanged. Nothing to save.');
        $('#infomodal').modal();
        return;
      }
  
      axios.post(`/api/v1/portal/jobs/set-invoice-notes/${this.state.data.id}`, {
        api_token: window.api_token,
        invoice_notes: invoice_notes
      })
        .then((response) => {
          $('#infomodallabel').html('Success');
          $('#infomodal .modal-body').html(response.data);
          $('#infomodal').modal();
        })
        .catch((error) => {
          let errors = error.response?.data || error.message || 'Unknown error';
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, ' + errors);
          $('#infomodal').modal();
        });
    } catch (err) {
      console.error('Unexpected error in handleSaveInvoiceNotes:', err);
      $('#infomodallabel').html('Error');
      $('#infomodal .modal-body').html('Sorry, an unexpected error occurred.');
      $('#infomodal').modal();
    }
  }
  render() {
    let unit = this.state.data.unit;
    let unit_data = this.state.data.unit && this.state.data.unit.units_data ? JSON.parse(this.state.data.unit.units_data): [];
    
    return (
      <div>
        <div className="row">
          {/* <div className="col-md-12">
            {this.state.data.fuel_included_in_job_price === 1 ?
              <strong>Fuel Included in Job Price</strong>
              :
              <strong>Fuel Not Included in Job Price</strong>
            }
          </div> */}
        </div>
        <div className="row">
        <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              {/* <h3>Dropoff Required</h3> */}
              <h3>Service Required</h3>
              <div className="time-label">{
                this.state.data.dropoff_preposition.
                toUpperCase()
              }&nbsp;
                {this.state.data.dropoff_day}/
                {this.state.data.dropoff_month}/
                {this.state.data.dropoff_year} @ {
                  this.state.data.dropoff_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Dropoff Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_dropoff_preposition?
                  this.state.data.scheduled_dropoff_preposition.
                  toUpperCase() : ''
                }&nbsp;
                {this.state.data.scheduled_dropoff_day?
                  this.state.data.scheduled_dropoff_day:''
                }/
                {this.state.data.scheduled_dropoff_month?
                  this.state.data.scheduled_dropoff_month:''
                }/
                {this.state.data.scheduled_dropoff_year?
                  this.state.data.scheduled_dropoff_year:''
                } @
                {this.state.data.scheduled_dropoff_time?
                  this.state.data.scheduled_dropoff_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Service Address</h3>
              <p><strong>House Number or Name:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.house_number_or_name
              }</p>
              <p><strong>Address Line 1:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.address_line_1
              }</p>
              <p><strong>Address Line 2:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.address_line_2
              }</p>
              <p><strong>Address Line 3:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.address_line_3
              }</p>
              <p><strong>Town/City:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.town_city
              }</p>
              <p><strong>County:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.county_area
              }</p>
              <p><strong>Country:</strong> {
                this.state.data.dropoff_address && this.state.data.dropoff_address.country
              }</p>
              <p><strong>Postcode:</strong> {
                (this.state.data.dropoff_address && this.state.data.dropoff_address.postcode != null) ?
                  this.state.data.dropoff_address && this.state.data.dropoff_address.postcode.
                  toUpperCase() : null
              }
              </p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address && this.state.data.dropoff_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address && this.state.data.dropoff_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.dropoff_address && this.state.data.dropoff_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.dropoff_address && this.state.data.dropoff_address.contact_telephone_number}
              </p>
            </div>

            { (!this.state.data.has_split_jobs) ? 
              <div className="subsection-container">
              <h3>Units</h3>
              <div>
                {/* {
                  this.state.data.unit.map((unit,index)=>{
                    return( */}
                      <div className="unit-details-container">
                        <p><strong>Unit Number: </strong> {(unit && unit.unit_number) ? unit.unit_number : ""}<br/></p>
                        <p><strong>Unit Type: </strong> {
                          (unit_data && unit_data.units && unit_data.units.length > 0) ?
                            unit_data.units
                            .map(u => `${u.unit_type.replace(/_/g, ' ')} (${u.unit_quantity})`)
                            .join(", ")
                            : (unit && unit.unit_type) ? 
                            (this.state.data.unit.length > 1 ? 
                              this.state.data.unit.map(u=>u.unit_type.replace(/_/g,' ')).join(", ")
                              : unit.unit_type.replace(/_/g,' ')
                            )
                            : ""
                          }<br /></p>
                        <p><strong>Unit Qty: </strong> {(unit && unit.unit_qty) ? unit.unit_qty : ""}<br/></p>
                        <p><strong>Unit Term: </strong> {(unit && unit.unit_term) ? unit.unit_term : ""}<br/></p>
                        <p><strong>Unit Price: </strong><strike>&pound;{(unit && unit.unit_price) ? unit.unit_price : ""}</strike>  &pound;{this.state.data.job_price}<br/></p>
                        {
                          (unit && unit.unit_term == 'long') ? 
                            <div>
                              <p><strong>Type of unit service: </strong> {(unit && unit.type_of_unit_service) ? unit.type_of_unit_service : ""}<br/></p>
                              <p><strong>Number of weeks required: </strong> {(unit && unit.number_of_weeks_required) ? unit.number_of_weeks_required : ""}<br/></p>
                              <p><strong>Required date: </strong>{(unit && unit.required_date) ? moment(unit.required_date).format('DD/MM/YYYY h:mm a') : ""}<br/></p>
                              <p><strong>Collection_date: </strong>{(unit && unit.collection_date) ? moment(unit.collection_date).format('DD/MM/YYYY h:mm a') : ""}<br/></p>
                              <p><strong>Can we dropoff in week before? : </strong> {(unit && unit.can_we_dropoff_in_week_before) ? 'Yes' : 'No'}<br/></p>
                              <p><strong>Ongoing? : </strong> {(unit && unit.is_ongoing) ? 'Yes' : 'No'}<br/></p>
                            </div>
                          : null
                        }
                        {
                          (unit && unit.unit_term == 'short') ? 
                            <div>
                              <p><strong>Date of event: </strong> {(unit && unit.date_of_event) ? moment(unit.date_of_event).format('DD/MM/YYYY h:mm a') : ""} <br/></p>
                              <p><strong>Pickup date: </strong> {(unit && unit.pickup_date) ? moment(unit.pickup_date).format('DD/MM/YYYY h:mm a') : ""}<br/></p>
                              <p><strong>Dropoff date: </strong>{(unit && unit.dropoff_date) ? moment(unit.dropoff_date).format('DD/MM/YYYY h:mm a') : ""}<br/></p>
                              <p><strong>Is same day pickup and dropoff? : </strong> {(unit && unit.is_same_day_pickup_and_dropoff) ? 'Yes':'No'}<br/></p>
                              <p><strong>Is weekend dropoff pickup? : </strong> {(unit && unit.is_weekend_dropoff_pickup) ? 'Yes' : 'No'}<br/></p>
                            </div>
                          : null
                        }
                        <hr/>
                      </div>
                    {/* )
                   })
                } */}
              </div>
              <br />
              {/* <p>
                <strong>Jet Wash Required: </strong>
                {this.state.data.jet_wash_required}
              </p>
              <p>
                <strong>Fleet Paperwork Requirement: </strong>
                {this.state.data.fleet_paperwork_required}
              </p>
              <p>
                <strong>Fuel included in Job Price? </strong>
                {this.state.data.fuel_included_in_job_price}
              </p>
              <p>
                <strong>Admin Fee: </strong>
                &pound;{
                this.state.data.admin_fee_in_pence / 100
              }
              </p> */}
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'cancelled')?
                <div>
                  <p>
                    <strong>Cancelled By : </strong>
                    {this.state.data.cancelled_by.full_name}
                  </p>
                  <p>
                    <strong>Cancelled Time : </strong>
                    {this.state.data.cancelled_at}
                  </p>
                  <p>
                    <strong>Cancellation Reason : </strong>
                    {this.state.data.cancellation_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'aborted')?
                <div>
                  <p>
                    <strong>Aborted By : </strong>
                    {this.state.data.aborted_by.full_name}
                  </p>
                  <p>
                    <strong>Aborted Time : </strong>
                    {this.state.data.aborted_at}
                  </p>
                  <p>
                    <strong>Abortion Reason : </strong>
                    {this.state.data.abortion_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'deleted')?
                <div>
                  <p>
                    <strong>Deleted By : </strong>
                    {this.state.data.deleted_by.full_name}
                  </p>
                  <p>
                    <strong>Deleted Time : </strong>
                    {this.state.data.deleted_at}
                  </p>
                  <p>
                    <strong>Deletion Reason : </strong>
                    {this.state.data.deletion_reason}
                  </p>
                </div>
                :null
              }
            </div>
            : null }
            <div className="subsection-container">
              <p><strong>3 Words : </strong><a className="d-none" target="_blank" href={"https://what3words.com/"+this.state.data.three_words_of_dropoff_address}>{this.state.data.three_words_of_dropoff_address}</a></p>
              <textarea className="form-control form-control-lg" id="three_words_of_dropoff_address"
                defaultValue={this.state.data?.three_words_of_dropoff_address?.trim() ? this.state.data.three_words_of_dropoff_address : (this.state.data?.whatwords?.trim() ? this.state.data.whatwords : '')}>
              </textarea>
              <br />
              <button className="btn btn-dark" onClick={this.handleThreeWordsUpdate}><i className="fa fa-save"></i> Save</button>
            </div>
            
          </div>
          
          <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              <h3>Pickup Required</h3>
              <div className="time-label">
                {this.state.data.pickup_preposition.toUpperCase()}&nbsp;
                {this.state.data.pickup_day}/
                {this.state.data.pickup_month}/
                {this.state.data.pickup_year} @ {
                this.state.data.pickup_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Pickup Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_pickup_preposition?
                  this.state.data.scheduled_pickup_preposition.
                  toUpperCase():''
                }&nbsp;
                {this.state.data.scheduled_pickup_day?
                  this.state.data.scheduled_pickup_day:''
                }/
                {this.state.data.scheduled_pickup_month?
                  this.state.data.scheduled_pickup_month:''
                }/
                {this.state.data.scheduled_pickup_year?
                  this.state.data.scheduled_pickup_year:''
                } @
                {this.state.data.scheduled_pickup_time?
                  this.state.data.scheduled_pickup_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Yard Address</h3>
              <p><strong>House Number or Name: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.house_number_or_name}</p>
              <p><strong>Address Line 1: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.address_line_1}</p>
              <p><strong>Address Line 2: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.address_line_2}</p>
              <p><strong>Address Line 3: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.address_line_3}</p>
              <p><strong>Town/City: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.town_city}</p>
              <p><strong>County: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.county_area}</p>
              <p><strong>Country: </strong>
                {this.state.data.pickup_address && this.state.data.pickup_address.country}</p>
              <p><strong>Postcode: </strong> {
                (this.state.data.pickup_address && this.state.data.pickup_address.postcode != null) ?
                  this.state.data.pickup_address && this.state.data.pickup_address.postcode.toUpperCase() :
                  null
              }</p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address && this.state.data.pickup_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address && this.state.data.pickup_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.pickup_address && this.state.data.pickup_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.pickup_address && this.state.data.pickup_address.contact_telephone_number}
              </p>
            </div>
            <div className="subsection-container">
              <h3>Driver</h3>
              <JobFullDetailsMainDetailsDriverBlock
                data={this.state.data}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="subsection-container">
              <h3>Customer</h3>
              <p><strong>Name: </strong>
                <a href={"/portal-admin/customers/view/"+
                this.state.data.customer.id}>{
                  this.state.data.customer.name
                }
                </a>
              </p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.telephone_1}</p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.telephone_2}</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Contact</h3>
              <p><strong>Name: </strong>{
                this.state.data.customer.contact_name
              }</p>
              <p><strong>Email: </strong> <a
                href={"mailto:"+
                this.state.data.customer.contact_email
                }>{this.state.data.customer.contact_email
              }</a></p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.contact_telephone_1
              }</p>
              <p><strong>Telephone: </strong> {
                this.state.data.customer.contact_telephone_2
              }</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Order Number</h3>
              <p><strong>{
                this.state.data.customer_order_number
              }</strong></p>
            </div>
            <div className="subsection-container">
              <h3>Customer Job Number</h3>
              <p><strong>{
                this.state.data.customer_job_number
              }</strong></p>
            </div>
            <div className="subsection-container">
              <h3>Special Instructions</h3>
              <textarea
                className="form-control form-control-lg"
                defaultValue={
                  this.state.data?.customer?.customer_historical_notes?.trim()
                    ? this.state.data.customer.customer_historical_notes
                    : (this.state.data?.instructions?.trim() ? this.state.data.instructions : '')
                }>
              </textarea>
              <br />
              {/* <button className="btn btn-dark">
                <i className="fa fa-save">
                </i> Save Special Instructions
              </button> */}
            </div>
            <div className="subsection-container">
              <h3>Notes</h3>
              <textarea className="form-control form-control-lg"
                        defaultValue={this.state.data.notes}>
              </textarea>
              <br />
              <button className="btn btn-dark">
                <i className="fa fa-save">
                </i> Save Notes
              </button>
            </div>
            <div className="subsection-container">
              <h3>Set Job Option</h3>
              <div className="text-left job-ref-font20">
                <label className="radio-inline">
                  <input type="radio" name="job_type" value="delivery" 
                  defaultChecked={(this.state.data.job_type == 'delivery') ? true : false}
                  onChange={(e)=>this.handleJobTypeOption(e)}/>&nbsp; Delivery &nbsp;
                </label>
                <label className="radio-inline">
                  <input type="radio" name="job_type"  value="collection" 
                  defaultChecked={(this.state.data.job_type == 'collection') ? true : false}
                  onChange={(e)=>this.handleJobTypeOption(e)}/>&nbsp; Collection &nbsp;
                </label>
                <label className="radio-inline">
                  <input type="radio" name="job_type" value="service" 
                  defaultChecked={(this.state.data.job_type == 'none' || this.state.data.job_type == 'service') ? true : false}
                  onChange={(e)=>this.handleJobTypeOption(e)}/>&nbsp; Service &nbsp;
                </label>
                <button className="btn btn-dark" onClick={() => {
                    this.handleJobTypeOptionSave()
                  }}>
                    <i className="fa fa-save"> </i>&nbsp; Save
                </button>
              </div>
            </div>
            <div className="subsection-container">
              <h3>Invoice Notes</h3>
              <textarea
                className="form-control form-control-lg"
                defaultValue={this.state.data.invoice_notes}
                ref={this.invoiceNotesRef}
                placeholder="Enter Invoice Notes"
              ></textarea>
              <br />
              <button
                className="btn btn-dark"
                onClick={this.handleSaveInvoiceNotes}
              >
                <i className="fa fa-save"></i> Save Notes
              </button>
            </div>
          </div>
        </div>
      </div>

    )
  }
}